import React, {Component} from 'react';
import {connect} from 'react-redux';
import store from 'store';

import {
    Button,
    Card, CardBody, CardHeader
} from 'reactstrap';
import {handleResendVerifyEmail} from "../owner/actions/owner";
import PolyUtil from "../../util/PolyUtil";

class ConfirmEmail extends Component {

    content = () => {
        const {email_verified, email, _handleResendVerifyEmail} = this.props;
        if (store.get('type') === 'landlord' && !email_verified) return (
            <Card outline color="danger" className="pr-card">
                <CardHeader tag="h4">Confirm Your Email</CardHeader>
                <CardBody>
                    <p>A confirmation link was sent in an email to {email}</p>
                    <p className="mt-1">You must complete this <i>before you can claim properties or view applied tenants.</i></p>
                    <hr/>
                    <Button color="primary" onClick={_handleResendVerifyEmail} outline>Resend Email</Button>
                </CardBody>
            </Card>
        );
        else return null;
    };

    render() {
        return PolyUtil.polyRender(this.props, ['email_verified', 'email'], this.content, null);
    }
}

const mapStateToProps = (state) => ({
    email_verified: state.owner.email_verified,
    email: state.activeUser.email
});

const mapDispatchToProps = (dispatch) => ({
    _handleResendVerifyEmail() {
        dispatch(handleResendVerifyEmail());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmail);


// WEBPACK FOOTER //
// ./src/containers/settings/ConfirmEmail.js